let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hWSI7")).then(() => parcelRequire('k8jhS'));